import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-point-filter',
  templateUrl: './point-filter.component.html',
  styleUrls: ['./point-filter.component.css']
})
export class PointFilterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
